import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';
import {ITableReportColumnFilerDto} from 'store/slices/table-report-slice/table-report-column-filters/table-report-column-filters-types';

const filtersBaseUrl = 'table-reports/filters';

export type TFetchTableColumnFiltersArgs = Pick<ITableReportColumnFilerDto, 'columnName' | 'templateCode'>

export const fetchTableColumnFilters = (args: TFetchTableColumnFiltersArgs) => (
    performRequest<ITableReportColumnFilerDto[]>({
        url: [filtersBaseUrl, 'filters'].join('/'),
        method: ERequestType.POST,
        data: args,
    })
);

export type TPostTableColumnFiltersArgs = Omit<ITableReportColumnFilerDto, 'id' | 'docId' | 'entityName'>

export const postTableColumnFilters = (args: TPostTableColumnFiltersArgs) => (
    performRequest<string>({
        url: [filtersBaseUrl, 'filter'].join('/'),
        method: ERequestType.POST,
        data: args,
    })
);

export type TUpdateTableColumnFiltersArgs = Omit<ITableReportColumnFilerDto, 'docId' | 'entityName'>

export const updateTableColumnFilters = (args: TUpdateTableColumnFiltersArgs) => (
    performRequest<string>({
        url: [filtersBaseUrl, 'filter'].join('/'),
        method: ERequestType.PUT,
        data: args,
    })
);

export type TDeleteTableColumnFiltersArgs = TPostTableColumnFiltersArgs

export const deleteTableColumnFilters = (args: TDeleteTableColumnFiltersArgs) => (
    performRequest<string>({
        url: [filtersBaseUrl, 'filter'].join('/'),
        method: ERequestType.DELETE,
        data: args,
    })
);
